"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _primaryPanel = require("./primary-panel");
var _index2 = _interopRequireDefault(require("../../../elements/buttons/link/index.js"));
/**
 * Local Imports
 */

// TODO: align-items and justify-content will need to be configurable
// through sitecore as part of operationalization if experiment wins
const SecondaryPanelContianer = /*#__PURE__*/(0, _react2.styled)(_primaryPanel.sharedDiv)({
  name: "SecondaryPanelContianer",
  class: "pl-s1hvvhfd",
  vars: {
    "s1hvvhfd-2": [({
      hasPromoButton
    }) => hasPromoButton ? '0.063rem solid rgba(68, 68, 68, 0.1)' : 'none']
  }
});
const PromoButton = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PromoButton",
  class: "pl-p8y5l7f"
});
const ButtonMobile = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ButtonMobile",
  class: "pl-b1b56zxv"
});

/**
 * SecondaryPanel Component.
 *
 * @param {Object} props React props
 * @param {Object} props.secondaryPanel Message Left Props
 * @returns {React.ReactElement} SecondaryPanel Component
 * @public
 */

function SecondaryPanel({
  secondaryPanel
}) {
  const {
    promoCta,
    eyebrow,
    partial
  } = secondaryPanel;
  const linkButtonProps = {
    _name: secondaryPanel?.ctas?.[0]?._name ?? '',
    text: secondaryPanel?.ctas?.[0]?.text ?? '',
    design: 'inline',
    href: secondaryPanel?.ctas?.[0]?.href || (secondaryPanel?.ctas?.[0]?.url ?? ''),
    icon: 'arrow-right',
    templateName: 'Link'
  };
  return /*#__PURE__*/_react.default.createElement(SecondaryPanelContianer, {
    "data-cy": "secondary-panel",
    "data-partial": partial,
    hasPromoButton: promoCta
  }, /*#__PURE__*/_react.default.createElement(_primaryPanel.HeadlineWrapper, {
    "data-cy": "secondary-headline"
  }, /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({
    textAlign: "start",
    headlineSize: "h5",
    headlineTag: eyebrow ? 'h3' : 'h2'
  }, secondaryPanel))), promoCta && /*#__PURE__*/_react.default.createElement(PromoButton, {
    "data-cy": "promo-button"
  }, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButtonSet, {
    templateMap: {
      Link: _index2.default
    },
    buttons: [promoCta]
  })), /*#__PURE__*/_react.default.createElement(ButtonMobile, {
    "data-cy": "link-button"
  }, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButtonSet, {
    templateMap: {
      Link: _index2.default
    },
    buttons: [linkButtonProps]
  })));
}
var _default = exports.default = SecondaryPanel;
SecondaryPanel.propTypes = {
  secondaryPanel: _propTypes.default.object
};